module.exports = __webpack_public_path__ + "img/seminar (54).ff4d6336.jpg";